import { pricingProceduresSlice } from "./pricingProceduresSlice";
import * as actions from "./pricingProceduresActions";
import * as selectors from "./pricingProceduresSelectors";

export { actions };
export { selectors };
export default pricingProceduresSlice.reducer;
